module.exports = __webpack_public_path__ + "img/yo-logo.25b79ff6.webp";